<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    id="abnormal-dialog"
    :show-close="false"
    >
    <span>您暂无权限查看当前商品</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleBack">返回供销商小店</el-button>
    </span>
    </el-dialog>
</template>

<script>
export default {
  data() {
    return{
      dialogVisible: false,
    }
  },
  methods: {
    handleBack() {
      this.dialogVisible = false;
      this.$router.replace({
        name: 'd_SupplierMineInfo',
        query: {
          supplierId: this.$route.query.supplierId
        }
      })
    },
    method_open() {
      this.dialogVisible = true
    },
  }

}
</script>

<style lang="scss" scoped>
   ::v-deep .el-dialog__body {
    min-height: 0;
  }
  
</style>

<style>
#abnormal-dialog  {
  backdrop-filter: blur(2px);
}
</style>
